import Lottie from "react-lottie-player";
import loading from "./changePasswordLoading.json";

export const ChangePasswordLoading = (props) => {
  return <Lottie animationData={loading} {...props} play />;
};
